// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3HhyJ","buttons":"RemoveExpirationActionButtons_buttons__2Vz_y"};